import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const DEFAULT_FILTERS = {
  ghId: '', wsi: '', name: '', fullName: '',
  stationTypes: [], elevationMin: '', elevationMax: '',
  hierarchyPaths: [], basin: [], stationOwners: [],
  elAbbreviations: [], elMatchMode: 'any',
  activeOnly: true,
  locality: null, localityRadius: '',
  plusGhId: '', minusGhId: '',
}

export const useStationGroupStore = create(
  persist(
    (set) => ({
      // Konfigurace úrovní skupiny, viz doc/plans/station-group-layout.md sekce I.1
      groupLevels: [],
      setGroupLevels: (groupLevels) => set({ groupLevels }),

      // Vybraná cesta stromem, např. [{levelIdx: 0, bucketLabel: 'Moravskoslezský kraj'}, ...]
      selectedPath: [],
      setSelectedPath: (selectedPath) => set({ selectedPath }),

      clearGroupSelection: () => set({ groupLevels: [], selectedPath: [] }),

      // Úplný reset na „vlastní výběr“ — vyprázdní definici skupiny i filtry a zruší vazbu na uloženou skupinu
      resetToBlank: () => set({
        groupLevels: [], selectedPath: [], filters: DEFAULT_FILTERS, editingSavedGroupId: null,
        groupFilterBaseline: null, productFilterBaseline: null,
      }),

      // Menu „Filtry“ — efektivní (zobrazený/upravovaný) filtr = sjednocení group_filter + detail
      // filtru aktuálního produktu, viz doc/plans/group-product-filters.md
      filters: DEFAULT_FILTERS,
      setFilters: (filters) => set({ filters }),

      // Poslední načtený group_filter editované skupiny (bez merge s produktem) — potřeba pro
      // "Uložit filtr ke skupině"/"Smazat filtr k produktu", aby šlo obnovit stav bez detailu.
      groupFilterBaseline: null,
      setGroupFilterBaseline: (groupFilterBaseline) => set({ groupFilterBaseline }),

      // Poslední načtený detail filtr (saved_station_group_filter) pro dvojici (skupina, aktuální
      // produkt) — null = pro tuhle dvojici žádný detail filtr neexistuje.
      productFilterBaseline: null,
      setProductFilterBaseline: (productFilterBaseline) => set({ productFilterBaseline }),

      // Menu „Produkty“ — zdroj pravdy je URL, ale poslední zvolený produkt držíme i tady, aby
      // přežil odskok na /station/:id a zpět (viz StationGroupLayout).
      activeProduct: 'map',
      setActiveProduct: (activeProduct) => set({ activeProduct }),

      // Co se zobrazuje vpravo (mapa vs. produkty) — persistováno, aby refresh nezahodil volbu
      rightView: 'map',
      setRightView: (rightView) => set({ rightView }),

      // Barevný mód mapy (produkt Mapa), viz sekce III
      mapColorMode: 'group', // 'group' (podle skupiny, preferovaný) | 'elevation' | 'type-color' | ...
      setMapColorMode: (mapColorMode) => set({ mapColorMode }),

      // id právě editované uložené skupiny (sekce VI, zatím bez backendu — připraveno pro budoucí použití)
      editingSavedGroupId: null,
      setEditingSavedGroupId: (editingSavedGroupId) => set({ editingSavedGroupId }),
    }),
    {
      name: 'station-group-store',
      storage: createJSONStorage(() => sessionStorage),
      // expandedPanel se řeší lokálně v layoutu (UI stav overlaye) — sem nepatří
      partialize: (s) => ({
        groupLevels: s.groupLevels,
        selectedPath: s.selectedPath,
        filters: s.filters,
        groupFilterBaseline: s.groupFilterBaseline,
        productFilterBaseline: s.productFilterBaseline,
        activeProduct: s.activeProduct,
        rightView: s.rightView,
        mapColorMode: s.mapColorMode,
        editingSavedGroupId: s.editingSavedGroupId,
      }),
    }
  )
)
